import * as React from "react";
import { Modal } from "react-bootstrap";

import { FrequencyCurveChart } from "./FrequencyCurveChart";
import { FrequencyCurve } from "../../../Types/Common/OscillometryTypes";

interface FrequencyCurveModalProps {
  show: boolean;
  onHide: () => void;
  frequencyCurve: FrequencyCurve | null | undefined;
  title?: string;
  rejected?: boolean;
}

export const FrequencyCurveModal: React.FC<FrequencyCurveModalProps> = ({
  show,
  onHide,
  frequencyCurve,
  title = "Frequency Curve (R & X)",
  rejected = false
}) => {
  return (
    <Modal
      show={show}
      onHide={onHide}
      centered
      size="lg"
      dialogClassName="frequency-curve-modal"
    >
      <Modal.Header closeButton style={{ borderBottom: "1px solid #e8e8e8" }}>
        <Modal.Title style={{ fontSize: "18px", fontWeight: 600 }}>
          {title}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body
        style={{
          padding: "24px",
          display: "flex",
          justifyContent: "center",
          backgroundColor: "#fafafa",
        }}
      >
        <FrequencyCurveChart
          frequencyCurve={frequencyCurve}
          height={500}
          width={500}
          rejected={rejected}
        />
      </Modal.Body>
    </Modal>
  );
};

export default FrequencyCurveModal;
